<template>
    <div>
      <ModalIdle v-if="isIdle" />
      <div v-if="userType != 'ADMIN'" class="overlay">
        <div style="background: white; width: 600px; box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12); border-radius: 4px; height: 250px;">

          <div style="text-align: center; padding-top: 75px;">
            <button @click="$router.push('/quotes')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:40px; padding-left:40px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
               Get a Quote
            </button>
            <br><br>
            <button @click="$router.push('/quoteHistory')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:34px; padding-left:34px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
               Quote History
            </button>
            <br><br>
            <button @click="$router.push('/orders')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
               Track your Order
            </button>
          </div>
        </div>
      </div>

      <div v-if="userType == 'ADMIN'" class="overlay">
        <div style="background: white; width: 600px; box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12); border-radius: 4px; height: 250px;">

          <div style="text-align: center; padding-top: 75px;">
            <button @click="$router.push('/quotes')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:40px; padding-left:40px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white; width:200px;">
               Create a Quote
            </button>
            <br><br>
            <button @click="$router.push('/quoteHistory')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:34px; padding-left:34px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white; width:200px;">
               Quote History
            </button>
            <br><br>
            <button @click="$router.push('/orders_sheet')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white; width:200px;">
               Orders Sheet
            </button>
          </div>
        </div>
      </div>      <!--
      <div v-if="!isMobile()" style="align-content: center; align-items: center; text-align: center; justify-content: center; vertical-align: middle !important;">
        <div style="margin-top: 250px;"></div>
        <div style="background-color: #e9e9e9; padding-top: 100px; padding-bottom: 100px; margin-right: 700px; margin-left: 700px; border-radius: 5px;">
          <button @click="$router.push('/quotes')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:40px; padding-left:40px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
             Get a Quote
          </button>
          <br><br>
          <button @click="$router.push('/orders')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
             Track your Order
          </button>
        </div>
      </div> 
      -->

      <!--
      <div v-if="isMobile()" style="align-content: center; align-items: center; text-align: center; justify-content: center; vertical-align: middle !important;">
        <div style="margin-top: 75px;"></div>
        <div style="background-color: #e9e9e9; padding-top: 135px; padding-bottom: 135px; margin-right: 20px; margin-left: 20px; border-radius: 5px;">
          <button @click="$router.push('/quotes')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:40px; padding-left:40px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
             Get a Quote
          </button>
          <br><br>
          <button @click="$router.push('/orders')" tabindex="-1" substrate="button" class="wizard-btn" style="padding-top:5px; padding-bottom: 5px; padding-right:25px; padding-left:25px; border-radius: 5px; background-color: rgb(0, 0, 0); border-color: rgb(0, 0, 0); color: white;">
             Track your Order
          </button>
        </div>
      </div>
      -->
    </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import axios from 'axios';

import ModalIdle from "@/views/components/ModalIdle.vue"

export default {
  components: {
    BRow,
    BCol,
    ModalIdle
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle
    }
  },
  data() {
    return {
      data: {},
      userType: 'REG'
    }
  },
  created() {
    // data
    this.$http.get('/ecommerce/data')
      .then(response => {
        this.data = response.data

        // ? Your API will return name of logged in user or you might just directly get name of logged in user
        // ? This is just for demo purpose
        const userData = JSON.parse(getUserData())
        this.data.congratulations.name = userData.fullName.split(' ')[0] || userData.username
        this.userType = userData.permissions
      })
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    googleApi() {
      var url = 'https://flexoapi.online/flexocraft/api/sheets/read-sheet.php'

      //console.log('request: ' + url)
      axios
      .get(url)
      .then(response => (console.log()))
      .catch(function (error) {
        console.log('error: ' + error)
      })
      .finally(function () {

      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';

	.overlay {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 100;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal {
		width: 500px;
		box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
		border-radius: 4px;
		background: white;
	}

	.modal__title {
		color: #38404f;
		@apply flex items-center justify-between p-3 font-bold;
	}
</style>
